import { Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AppBarModule } from '@psu-pennstateit-swe/components/layout';
import { ExternalLinkModule } from '@psu-pennstateit-swe/utils/angular';
import { CdnModule } from '@psu-pennstateit-swe/utils/cdn';

@Component({
  selector: 'app-root',
  imports: [AppBarModule, ExternalLinkModule, CdnModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private matIconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  constructor() {
    this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl('mdi.svg'));
  }
}
